module.exports = __webpack_public_path__ + "img/3.7c819ed9.png";